module.exports = __webpack_public_path__ + "img/XButton.31d8746f.svg";